import type { ServiceOrderCreateFormValues } from '@/features/order/service-order-form.types.ts'

export const CREATE_INITIAL_VALUES: ServiceOrderCreateFormValues = {
  items: [{ fileIds: [], note: '' }],
  orderGroupMode: 'none',
  orderGroupName: ''
}
